import React, { useState, useEffect } from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";
import Link from "../../Link";
import { styled } from '../../../stitches.config';

export default props => {
  const size = window.innerWidth > 992 ? "md" : "lg";
  const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
  //data prawidłowa
  const finishTime = Date.parse('2022-01-03T23:59:00');

  //ta na testy zakończenia odlcizania
  //const finishTime = Date.parse('2021-12-01T23:59:00');

  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [countownEnded, setCountownEnded] = React.useState(false);

  const calculateTime = (deadline) => {
    const time = deadline - Date.now();
    if (time < 0) {
      setDays(0)
      setHours(0)
      setMinutes(0)
      setSeconds(0)
      setCountownEnded(true);
    } else {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)))
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24))
      setMinutes(Math.floor((time / 1000 / 60) % 60))
      setSeconds(Math.floor((time / 1000) % 60))
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      calculateTime(finishTime);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const leadingNumber = (value) => value < 10 ? "0" + value : value;

  return (
    <StyledSection className="container">
      <StyledCountdown className="countdown">
        {countownEnded ? (
          <StyledCountdownText>
            <span>Tekst timera</span>
          </StyledCountdownText>

        ) : (
          <>
            <div className="countdown__wrap"><span>{String(leadingNumber(days))}</span><span>dni</span></div>
            <div className="countdown__wrap"><span>:</span></div>
            <div className="countdown__wrap"><span>{String(leadingNumber(hours))}</span><span>godziny</span></div>
            <div className="countdown__wrap"><span>:</span></div>
            <div className="countdown__wrap"><span>{String(leadingNumber(minutes))}</span><span>minuty</span></div>
            <div className="countdown__wrap"><span>:</span></div>
            <div className="countdown__wrap"><span>{String(leadingNumber(seconds))}</span><span>sekundy</span></div>
          </>
        )}

      </StyledCountdown>
      {countownEnded ? (
        <>
        </>
      ) : (
        <>
        </>
      )}

      <Wrapper className="row" pcs={pcs}>
        <div className="col-xs-12 col-md-4">
          <Box {...props} id="b1" type="APhotoOnTop" settings={props.settings.b1} size={size} classes="" />
        </div>
        <div className="col-xs-12 col-md-4">
          <Box {...props} id="b2" type="APhotoOnTop" settings={props.settings.b2} size={size} classes="" />
        </div>
        <div className="col-xs-12 col-md-4">
          <Box {...props} id="b3" type="APhotoOnTop" settings={props.settings.b3} size={size} classes="" />
        </div>
      </Wrapper>
    </StyledSection>
  );
}

const StyledSection = styled("section", {
  position: "relative",
  backgroundSize: "100%",
  backgroundPosition: "top center",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#020911",
  backgroundImage: "none",
  "@media (min-width:992px)": {
    backgroundImage: "none"
  },
  "& > a": {
    "&:hover": {
      textDecoration: "none"
    }
  }
});

const StyledCountdown = styled("div", {
  fontFamily: '"Hurme"',
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center",
  "@media (min-width:992px)": {},
  "& > div": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&:nth-of-type(odd)": {
      width: "55px"
    },
    "&:nth-of-type(even)": {
      width: "15px"
    },
    "@media (min-width:992px)": {
      "&:nth-of-type(odd)": {
        width: "80px"
      },
      "&:nth-of-type(even)": {
        width: "15px"
      }
    },
    "& > span": {
      color: "white",
      fontSize: "12px",
      "@media (min-width:992px)": {
        fontSize: "16px"
      }
    },
    "& > span:first-of-type": {
      fontWeight: "bold",
      fontSize: "35px",
      "@media (min-width:992px)": {
        fontSize: "40px"
      }
    }
  },
  "& >span": {
    color: "white",
    fontSize: "40px"
  }
});

const StyledCountdownText = styled("p", {
  display: "flex",
  flexDirection: "row",
  webkitBoxPack: "center",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "15px",
  marginBottom: "25px",
  width: "auto",
  "&::hover": {
    textDecoration: "none"
  },
  "& > img": {
    width: "152px"
  },
  "& > span": {
    marginTop: "6px",
    fontWeight: "lighter",
    fontSize: "14px",
    letterSpacing: "1.2px",
    color: "white",
    textTransform: "uppercase",
    marginRight: "-6px"
  }
});